











































































































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import GlobalMixins from '../mixins'
import { bus, zirafHTTP } from '../main'
import QuestionTerms from '../components/QuestionTerms.vue'

@Component({
	components: {
		QuestionTerms
	}
})
export default class Client extends GlobalMixins {
	client = {
		id: '',
		name: '',
		email: '',
		phone: '',
		position: '',
		location: '',
		contact: '',
		testValues: '',
		type: 'Client',
		active: false
	}
	clientErrors = {
		name: false,
		email: false,
		phone: false,
		position: false,
		location: false,
		contact: false
	}
	clientErrorMessages = {
		name: '',
		email: '',
		phone: '',
		position: '',
		location: '',
		contact: ''
	}
	canSave: boolean = false
	clientSinceLastSave: string = ''
	allCallsMade: {
		client: boolean,
		questions: boolean
	} = {
		client: false,
		questions: false
	}
	questions: false | any[] = false
	testValues: any | false = false
	errorOnQuestion: number[] = []

	get testBaseUrl(): string {
		return process.env.VUE_APP_TEST_BASEURL
	}
	get clientTestFeedback(): any {
		if (this.client.testValues) {
			if (!this.questions) return false
	
			const answers = JSON.parse(((<any>this.client).testValues))
			const testFeedback: {answer: string, title: string}[] = []

			;[...this.questions].forEach((question: any, index: number) => {
				if (question.type === 'feedback') {
					if (answers && answers[index]) {
						testFeedback.push({
							answer: answers[index],
							title: question.title.Client ? question.title.Client : question.title
						})
					}
				}
			})

			if (testFeedback.length) {
				return testFeedback
			} else {
				false
			}
		} else {
			return false
		}
	}

	@Watch('client', {deep: true})
	onClientChange(): void {
		this.$store.dispatch('setPreventNavigation', {prevent: false})

		document.title = `${process.env.VUE_APP_TITLE} | ${this.$route.meta.title} | ${this.client.name} | ${this.client.position}`

		this.clientErrors = {
			name: false,
			email: false,
			phone: false,
			position: false,
			location: false,
			contact: false
		}
		this.clientErrorMessages = {
			name: '',
			email: '',
			phone: '',
			position: '',
			location: '',
			contact: ''
		}
		this.canSave = false

		if (!this.client.name) {
			this.clientErrors.name = true
			this.clientErrorMessages.name = 'De naam kan niet leeg zijn'
		}
		if (!this.client.position) {
			this.clientErrors.position = true
			this.clientErrorMessages.position = 'De functie kan niet leeg zijn'
		}
		if (!this.client.location) {
			this.clientErrors.location = true
			this.clientErrorMessages.location = 'De locatie kan niet leeg zijn'
		}
		if (!this.client.contact) {
			this.clientErrors.contact = true
			this.clientErrorMessages.contact = 'De contactpersoon kan niet leeg zijn'
		}
		if (!this.client.email || (this.client.email && !this.validateEmail(this.client.email))) {
			this.clientErrors.email = true
			this.clientErrorMessages.email = !this.client.email ? 'E-mail adres mag niet leeg zijn' : 'E-mail adres is niet geldig'
		}
		if (!this.client.phone) {
			this.clientErrors.phone = true
			this.clientErrorMessages.phone = 'Het telefoonnummer kan niet leeg zijn'
		} else if (this.phoneContainsLetters(this.client.phone)) {
			this.clientErrors.phone = true
			this.clientErrorMessages.phone = 'Het telefoonnummer mag geen letters bevatten'
		}

		if (!this.clientErrors.name && !this.clientErrors.position && !this.clientErrors.location && !this.clientErrors.contact && !this.clientErrors.email && !this.clientErrors.phone && this.questions) {
			let testValuesCorrect = true

			this.errorOnQuestion = []

			if (this.testValues) {
				;[...this.questions].forEach((question: any, index: number) => {
					const answer = this.testValues[index]
					let questionError = false
		
					switch(question.type) {
						case 'versus':
							let allOptionsSelected = true
			
							;[...answer].forEach((option: string | null) => {
								if (!option) allOptionsSelected = false
							})
			
							if (!allOptionsSelected) {
								testValuesCorrect = false
								questionError = true
							}				
							break
						case 'image-comparison':
							if (!answer || answer.length !== question.choices.length) {
								testValuesCorrect = false
								questionError = true
							}
							break
						case 'panels':
						case 'word-cloud':
							if (!answer || !answer.length) {
								testValuesCorrect = false
								questionError = true
							}
							break
						case 'word-cloud-multiple':
							;[...answer].forEach((cloud: string[]) => {
								if (cloud.length < 1) {
									testValuesCorrect = false
									questionError = true
								}
							})
							break
						case 'terms':
							if (!answer) {
								testValuesCorrect = false
								questionError = true
							}
							if (!answer.salary) {
								testValuesCorrect = false
								questionError = true
							}
							if (!answer.salary.min || answer.salary.min < 0) {
								testValuesCorrect = false
								questionError = true
							}
							if (!answer.salary.max || answer.salary.min > answer.salary.max) {
								testValuesCorrect = false
								questionError = true
							}
							if (!answer.hours) {
								testValuesCorrect = false
								questionError = true
							}
							if (!answer.hours.min || answer.hours.min < 0) {
								testValuesCorrect = false
								questionError = true
							}
							if (!answer.hours.max || answer.hours.min > answer.hours.max) {
								testValuesCorrect = false
								questionError = true
							}
							if (!answer.car) {
								testValuesCorrect = false
								questionError = true
							}
							break
						case 'feedback':
							break
						default:
							testValuesCorrect = false
							questionError = true
					}

					if (questionError) {
						this.errorOnQuestion.push(index)
					}
				})
			} else {
				testValuesCorrect = true
			}

			this.$store.dispatch('setPreventNavigation', {prevent: this.clientSinceLastSave !== JSON.stringify(this.client), message: 'Er zijn onopgeslagen wijzigingen. Weet je zeker dat je de pagina wilt verlaten?'})

			if (testValuesCorrect) {
				this.canSave = this.clientSinceLastSave !== JSON.stringify(this.client)
			} else {
				this.canSave = false
			}
		}
	}
	@Watch('allCallsMade', {deep: true})
	onAllCallsMadeChange() {
		if (this.allCallsMade.client && this.allCallsMade.questions) {
			bus.$emit('initCompleteContent')
		}
	}
	@Watch('testValues', {deep: true})
	onTestValuesChange() {
		if (this.client && this.testValues) {
			this.client.testValues = JSON.stringify(this.testValues)
		}
	}

	save(): void  {
		if (this.clientSinceLastSave === JSON.stringify(this.client)) return

		const clientLastSave = JSON.parse(this.clientSinceLastSave)
		let name = false
		let email = false
		let phone = false
		let changedClient: { [key: string]: any } = {}

		if (clientLastSave.name !== this.client.name || clientLastSave.position !== this.client.position || clientLastSave.location !== this.client.location) {
			changedClient['position'] = this.client.position
			changedClient['location'] = this.client.location
			changedClient['name'] = this.client.name
		}

		if (clientLastSave.contact !== this.client.contact) changedClient['contact'] = this.client.contact
		if (clientLastSave.email !== this.client.email) changedClient['email'] = this.client.email
		if (clientLastSave.phone !== this.client.phone) changedClient['phone'] = this.client.phone
		if (clientLastSave.active !== this.client.active) changedClient['active'] = this.client.active
		if (clientLastSave.testValues !== this.client.testValues) changedClient['testValues'] = this.client.testValues

		zirafHTTP.put('clients/' + this.$route.params.id, changedClient)
			.then(response => {
				const {id, ...client} = response.data

				this.client = client
				this.clientSinceLastSave = JSON.stringify(client)
				
				bus.$emit('pushNotification', {
					message: 'Aanpasingen zijn opgeslagen'
				})
			})
			.catch(error => {
				console.error(error.response.data)
				
				this.checkIfSessionExpired(error.response.data.errorCode, () => {
					if (error.response.data.errorCode === 10351) {
						bus.$emit('pushNotification', {
							error: true,
							message: this.returnErrorByCode(10351)
						})
					} else {
						bus.$emit('pushNotification', {
							error: true,
							message: 'De klant kon niet worden aangepast'
						})
					}
				})
			})
	}
	deleteClient(): void {
		const confirmEvent = 'deleteClient'
		const rejectEvent = 'cancelDeleteClient'

		bus.$on(confirmEvent, () => {
			bus.$off(confirmEvent)
			bus.$off(rejectEvent)

			zirafHTTP.delete(`clients/${this.$route.params.id}`)
				.then(response => {
					if (response.data.affected) {
						bus.$emit('pushNotification', {
							message: 'Klant verwijderd'
						})

						Vue.nextTick(() => {
							this.$store.dispatch('setPreventNavigation', {prevent: false})
							this.$router.push({ name: 'clients' })
						})
					}
				})
				.catch(error => {
					this.checkIfSessionExpired(error.response.data.errorCode, () => {
						console.error(error.response.data)
					})
				})
		})
		bus.$on(rejectEvent, () => {
			bus.$off(confirmEvent)
			bus.$off(rejectEvent)
		})

		bus.$emit('openModal', {
			message: `Weet je zeker dat je <i>${this.client.position}</i> van <i>${this.client.name}</i> wilt verwijderen?`,
			confirm: {
				label: 'Verwijderen',
				event: confirmEvent
			},
			reject: {
				label: 'Annuleren',
				event: rejectEvent
			}
		})
	}
	backToTop() {
		bus.$emit('backToTop')
	}
	
	mounted() {
		bus.$on('updateEntityTerms', (payload: {questionIndex: number, entityTerms: {salary: {min: number, max: number}, hours: {min: number, max: number}, car: string}}) => {
			this.testValues.splice(payload.questionIndex, 1, payload.entityTerms)
		})
		bus.$on('preventedNavigation', () => {
			document.title = `${process.env.VUE_APP_TITLE} | ${this.$route.meta.title} | ${this.client.name} | ${this.client.position}`
		})

		zirafHTTP.get(`clients/${this.$route.params.id}`)
			.then(response => {
				const {id, ...client} = response.data

				this.client = client
				this.clientSinceLastSave = JSON.stringify(client)
				this.testValues = JSON.parse(client.testValues)

				document.title = `${document.title} | ${this.client.name} | ${this.client.position}`

				this.allCallsMade.client = true
			})
			.catch(error => {
				console.error(error.response.data)
				
				this.checkIfSessionExpired(error.response.data.errorCode, () => {
					this.$router.replace({name: 'pageNotFound'})
				})
			})
			
		zirafHTTP.get('test/questions')
			.then(response => {
				this.questions = response.data

				this.allCallsMade.questions = true
			})
			.catch(error => {
				console.error(error.response.data)
				
				this.checkIfSessionExpired(error.response.data.errorCode, () => {
					this.$router.replace({name: 'pageNotFound'})
				})
			})
	}
	beforeDestroy() {
		bus.$off('updateEntityTerms')
	}
}
